module.exports = __webpack_public_path__ + "static/media/ic-checkmark-green.fea67eef.svg";